export default "/images/61ff37c31cd6aaf0ed6b605f803a8bcf.avif";